import { isFlagEnabled } from '../backoffice/platformFlagEffective.js';
/** Literal `true` required (same pattern as CJ / Geo / SEO Content Manager). */

export const ADSENSE_REPORTING_ENABLED_ENV = 'ADSENSE_REPORTING_ENABLED';
export const ADSENSE_ACCOUNT_ID_ENV = 'ADSENSE_ACCOUNT_ID';
export const ADSENSE_OAUTH_CLIENT_ID_ENV = 'ADSENSE_OAUTH_CLIENT_ID';
export const ADSENSE_OAUTH_CLIENT_SECRET_ENV = 'ADSENSE_OAUTH_CLIENT_SECRET';
export const ADSENSE_OAUTH_REFRESH_TOKEN_ENV = 'ADSENSE_OAUTH_REFRESH_TOKEN';

/** AdSense console Publisher ID (`pub-…`; client script uses `ca-pub-…`). */
export const DEFAULT_ADSENSE_PUBLISHER_ID = 'pub-4184418527306835';

/** AdSense console Customer ID (account reference; not used in ads.txt). */
export const DEFAULT_ADSENSE_CUSTOMER_ID = '1206852620';

/** AdSense Management API v2 account resource name. */
export const DEFAULT_ADSENSE_ACCOUNT_ID = `accounts/${DEFAULT_ADSENSE_PUBLISHER_ID}`;

/** IAB ads.txt line for Google AdSense (must match `public/ads.txt`). */
export const ADSENSE_ADS_TXT_LINE = `google.com, ${DEFAULT_ADSENSE_PUBLISHER_ID}, DIRECT, f08c47fec0942fa0`;
export const ADSENSE_ADS_TXT_BODY = `${ADSENSE_ADS_TXT_LINE}\n`;

export const ADSENSE_READONLY_SCOPE = 'https://www.googleapis.com/auth/adsense.readonly';

/** In-process cache TTL for dashboard report fetches. */
export const DEFAULT_ADSENSE_REPORT_CACHE_TTL_MS = 20 * 60 * 1000;

export function isAdSenseReportingEnabled(
  env: Record<string, string | undefined> = process.env,
): boolean {
  return isFlagEnabled(ADSENSE_REPORTING_ENABLED_ENV, env);
}

export function getAdSenseAccountId(
  env: Record<string, string | undefined> = process.env,
): string {
  const raw = env[ADSENSE_ACCOUNT_ID_ENV]?.trim();
  if (!raw) return DEFAULT_ADSENSE_ACCOUNT_ID;
  if (raw.startsWith('accounts/')) return raw;
  if (raw.startsWith('pub-') || raw.startsWith('ca-pub-')) {
    const pub = raw.replace(/^ca-/, '');
    return `accounts/${pub}`;
  }
  return `accounts/${raw}`;
}

export function getAdSenseOAuthClientId(
  env: Record<string, string | undefined> = process.env,
): string | null {
  const v = env[ADSENSE_OAUTH_CLIENT_ID_ENV]?.trim();
  return v || null;
}

export function getAdSenseOAuthClientSecret(
  env: Record<string, string | undefined> = process.env,
): string | null {
  const v = env[ADSENSE_OAUTH_CLIENT_SECRET_ENV]?.trim();
  return v || null;
}

export function getAdSenseOAuthRefreshToken(
  env: Record<string, string | undefined> = process.env,
): string | null {
  const v = env[ADSENSE_OAUTH_REFRESH_TOKEN_ENV]?.trim();
  return v || null;
}

export function isAdSenseReportingConfigured(
  env: Record<string, string | undefined> = process.env,
): boolean {
  return Boolean(
    getAdSenseOAuthClientId(env) &&
      getAdSenseOAuthClientSecret(env) &&
      getAdSenseOAuthRefreshToken(env),
  );
}

export function getAdSenseReportCacheTtlMs(
  env: Record<string, string | undefined> = process.env,
): number {
  const n = Number.parseInt(env.ADSENSE_REPORT_CACHE_TTL_MS || '', 10);
  if (Number.isFinite(n) && n >= 60_000) return n;
  return DEFAULT_ADSENSE_REPORT_CACHE_TTL_MS;
}
